import * as surveys from 'api/surveys';
import {
  FinishCustomBlockData,
  GetAvailabilityRes,
  PostConsultationData,
  SendAvailabilityData,
  SendContactData,
  PutContactInformationResponse,
  SendFeedbackInformationData,
  SurveyContent,
} from 'api/surveys/types';
import { createActionFactories } from 'shared/helpers/actions';

import { GetContentPayload } from './types';
import { OnboardingFormData, OnboardingResponse } from '../../api/onboarding/types';
import * as onboarding from '../../api/onboarding';

const { createAsync } = createActionFactories('_resources/survey');

export const getContent = createAsync<GetContentPayload, SurveyContent>(
  'GET_SURVEY_CONTENT',
  (payload) => {
    const { url } = payload;

    return surveys.getContent(url);
  },
);

export const putAvailability = createAsync<SendAvailabilityData, unknown>(
  'PUT_AVAILABILITY',
  async (payload) => {
    return await surveys.sendAvailability(payload);
  },
);

export const getAvailability = createAsync<string, GetAvailabilityRes>(
  'GET_AVAILABILITY',
  async (payload) => {
    return surveys.getAvailability(payload);
  },
);

export const putContactInfo = createAsync<SendContactData, PutContactInformationResponse>(
  'PUT_CONTACT',
  async (payload) => {
    return await surveys.sendContactInfo(payload);
  },
);

export const postFeedback = createAsync<SendFeedbackInformationData, unknown>(
  'POST_SURVEY_FEEDBACK',
  async (payload) => {
    return await surveys.sendFeedbackInformation(payload);
  },
);

export const postConsultation = createAsync<PostConsultationData, unknown>(
  'POST_CONSULTATION',
  async (payload) => {
    return await surveys.finishConsultation(payload);
  },
);

export const postCustomBlock = createAsync<FinishCustomBlockData, unknown>(
  'POST_CUSTOM_BLOCK',
  async (payload) => {
    return await surveys.finishCustomBlock(payload);
  },
);
